<template>
  <Modal
    title="Cadastrar nova ocorrência"
    :active.sync="active"
    @close="closeModal"
  >
    <div class="">
      <vs-textarea
        class="mb-2 my-5"
        placeholder="Descreva a ocorrência"
        v-model="form.description"
        data-testId="occurrence-textarea"
      />

      <div class="flex flex-row gap-4 items-center">
        <span class="text-base font-bold">Anexos:</span>

        <div>
          <vs-input
            id="Upload de arquivos"
            name="Upload de arquivos"
            type="file"
            hidden
            style="display: none"
            @change="handleFiles($event.target.files)"
          />
          <vs-button
            @click.prevent="chooseFiles('Upload de arquivos')"
            data-testId="upload-file-button"
            icon-pack="feather"
            icon="icon-upload"
          >
          </vs-button>
        </div>
      </div>

      <div
        v-for="(item, index) in form.attachments"
        :key="index"
        class="flex flex-row items-center pt-2"
      >
        <span>
          {{ item.name }}
        </span>
        <div @click="removeFile(index)">
          <vs-icon
            class="ml-2 trash-icon"
            color="danger"
            icon-pack="feather"
            icon="icon-trash-2"
            size="small"
          ></vs-icon>
        </div>
      </div>

      <div class="mt-4 flex flex-row justify-end items-end">
        <vs-button
          :disabled="noDescription"
          style="height: min-content"
          color="success"
          @click="save"
          >Salvar</vs-button
        >
      </div>
    </div>
  </Modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import autoApi from '../../services/auto.api';
import functions from '../../utils/functions';
import notify from '../../utils/notify';

export default {
  name: 'ModalCadastroOcorrencias',
  props: ['apoliceId'],
  components: { Modal },
  data() {
    return {
      active: false,
      maxSize50Mb: 50 * 1024 * 1024,
      maxSizeMessage: 'O arquivos selecionados devem ter no total 50MB.',
      form: {
        policyId: null,
        description: '',
        attachments: [],
      },
    };
  },
  computed: {
    noDescription() {
      return this.form.description === '';
    },
  },
  methods: {
    openModal() {
      this.active = true;
    },
    closeModal() {
      this.form.description = '';
      this.form.attachments = [];
      this.active = false;
      this.$emit('close');
    },
    handleFiles(file) {
      const size = file[0].size;

      if (size > this.maxSize50Mb) {
        notify.notifyFail(this.$vs, this.maxSizeMessage);
        return;
      }

      const sanitizedFileName = functions.sanitizeString(file[0].name);
      const sanitizedFile = new File([file[0]], sanitizedFileName, {
        type: file[0].type,
      });

      this.form.attachments.push(sanitizedFile);
    },
    chooseFiles(inputId) {
      document.getElementById(inputId).click();
    },
    removeFile(index) {
      this.form.attachments.splice(index, 1);
    },
    async save() {
      try {
        this.form.policyId = this.apoliceId;
        const allFilesSize = this.form.attachments.reduce(
          (acc, file) => acc + file.size,
          0,
        );

        if (allFilesSize > this.maxSize50Mb) {
          notify.notifyFail(this.$vs, this.maxSizeMessage);
          return;
        }

        this.$vs.loading();
        await autoApi.saveOccurrence(this.form);
        notify.notifySuccess(this.$vs, 'Ocorrência cadastrada com sucesso.');
        this.$vs.loading.close();
        this.closeModal();
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao cadastrar ocorrência.');
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-file-upload {
  margin-bottom: 16px;
}

.trash-icon {
  cursor: pointer;
  padding: 5px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.trash-icon:hover {
  background-color: rgb(252, 230, 230);
}

.file-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.file-input {
  display: none;
}

.select-file-button {
  margin-bottom: 8px;
}

.file-preview {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.file-name {
  display: inline-block;
  max-width: 320px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 12px;
  font-size: 14px;
}

.file-preview .vs-button {
  margin-left: auto;
}
</style>
